// document
//   .querySelectorAll(
//     ".shopify-section.shopify-section-group-header-group.shopify-section-header"
//   )
//   .forEach((header) => {
//     header.onmouseover = () => {
//       console.log(header);
//       header.classList.add("shopify-section-header-sticky");
//     };
//     header.onmouseout = () => {
//       header.classList.remove("shopify-section-header-sticky");
//     };
//     header.onmouseup = () => {
//       header.classList.remove("shopify-section-header-sticky");
//     };
//   });
// shopify-section shopify-section-group-header-group shopify-section-header shopify-section-header-sticky animate

document.querySelectorAll(".media-slideshow__wrapper").forEach((media) => {
  if (media.classList.contains("media-slideshow__wrapper--half")) {
    media.classList.contains("media-slideshow__wrapper--half");
    media.parentElement.classList.add("mt-9minus");
    console.log("found");
  }
});

// document.querySelectorAll(".shopify-section-header").forEach((header) => {
//   header.addEventListener("onscroll", () => {
//     console.log("scrolled");
//   });
// });

// window.onscroll = function () {
//   myFunction();
// };